import config from '@/config';
import { fetchData } from '@/model/utils/fetch';
import {
  FetchJackpotsV2DataParams,
  JackpotsV2MultipleResponseType,
  JackpotsV2ResponseType,
} from '@/types/jackpotTypes';
import { parseJackpotGameProvider } from '@/utils/jackpotsV2/parseJackpotGameProvider';

export const fetchJackpotsV2 = async ({
  currency,
  gamesJackpotCodes,
  provider,
}: FetchJackpotsV2DataParams) => {
  try {
    const res = await fetchData<JackpotsV2ResponseType>({
      url: `${config.urls.bffBaseUrl}/jackpots/v2/${parseJackpotGameProvider(
        provider
      )}`,
      queryParameters: {
        code: gamesJackpotCodes,
        currency,
      },
    });

    return res;
  } catch (err) {
    console.error(
      `There was a problem while fetching JackpotsV2 data. ${config.urls.bffBaseUrl}/jackpots/v2/${provider}`
    );
    console.error(err);
    return {};
  }
};

export const fetchJackpotsV2Multiple = async ({
  currency,
  gamesJackpotCodes,
  provider,
}: FetchJackpotsV2DataParams) => {
  try {
    const jackpotProvider = parseJackpotGameProvider(provider);
    const response = await fetchData<JackpotsV2MultipleResponseType>({
      url: `${config.urls.bffBaseUrl}/jackpots/v2/multiple/${jackpotProvider}`,
      queryParameters: {
        code: Array.from(new Set(gamesJackpotCodes)),
        currency,
      },
    });

    return response;
  } catch (err) {
    console.error(
      `There was a problem while fetching JackpotsV2 Multiple data. ${config.urls.bffBaseUrl}/jackpots/v2/multiple/${provider}`
    );
    console.error(err);
    return {};
  }
};
